import './ListViewSwitcher.scss'

import { cls } from '@react/utils/classname'
import { trackEvent } from '@site/js/utils/tracking'
import { useState } from 'react'

type ListViewSwitcherPropsType = {
  listViewTemplates: {
    name: string
    icon: string
  }[]
  onListViewSwitcher: (templateName: string) => void
  disabled?: boolean
}

const getSessionListValue = (templates: { name: string; icon: string }[]) => {
  const stored = sessionStorage.getItem('listView')
  if (!stored || !templates?.length) return 0
  const idx = templates.findIndex(t => t.name === stored)
  return idx >= 0 ? idx : 0
}

export const ListViewSwitcher = ({ listViewTemplates, onListViewSwitcher, disabled }: ListViewSwitcherPropsType) => {
  const [activeView, setActiveView] = useState(() => getSessionListValue(listViewTemplates))

  const onClickHandler = (name: string, index: number) => {
    setActiveView(index)
    onListViewSwitcher(name)
    sessionStorage.setItem('listView', name)
    trackEvent({
      event: 'interaction',
      eventSource: 'aem',
      action: 'click',
      componentName: 'list-view-switcher',
      interactionType: name,
      title: name,
      href: '',
    })
  }

  return (
    listViewTemplates && (
      <div className={cls({ 'cmp-list-view-switcher': true, 'cmp-list-view-switcher--disabled': disabled })}>
        {listViewTemplates.map((template, index) => (
          <button
            aria-label={template.name}
            key={index}
            className={cls({ 'cmp-button': true, 'is-active': index === activeView })}
            onClick={() => onClickHandler(template.name, index)}
            disabled={disabled}
          >
            <span className={`cmp-button__icon cmp-button__icon--${template.icon}`}></span>
          </button>
        ))}
      </div>
    )
  )
}
